<template>
  <v-container>
    <highcharts v-if="loaded" :options="chartOptions"></highcharts>
    <v-progress-circular v-else indeterminate color="black" size="80" width="2" class="mb-5" style="margin-left: 50%" />
  </v-container>
</template>

<script>
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  import HighchartsNoData from 'highcharts/modules/no-data-to-display';
  import Boost from 'highcharts/modules/boost';
  HighchartsNoData(Highcharts);
  More(Highcharts);
  Boost(Highcharts);
  import PredicoesBaixasService from '@/services/PredicoesBaixasService';

  export default {
    name: 'GraficoHistogramaPredicao',

    props: {
      base: {
        type: String,
        required: true
      },
      idPredicao: {
        type: Number
      },
      idBaixaTucagem: {
        type: Number
      },
      variavelValor: {
        type: String
      }
    },

    emits: ['recharge'],

    data() {
      return {
        histogramaData: [],
        loaded: false
      };
    },

    computed: {
      seriesColor: function () {
        switch (this.variavelValor) {
          case 'voc':
            return '#96CAF1';
          case 'voc residual':
            return '#F7C6BB';
          case 'vnr':
            return '#4CAF50';
          case 'vnr residual':
            return '#FFCC66';
          default:
            return '#353535';
        }
      },

      chartOptions: function () {
        return {
          chart: {
            type: 'column'
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: ''
            }
          },
          tooltip: {
            headerFormat: '<table>',
            pointFormat:
              '<tr><td style="color:#E5502C;padding:0"> Faixa: </td> <td style="padding:0"><b>{point.faixa}</b></td></tr>' +
              '<tr><td style="color:#E5502C;padding:0"> Quantidade de combinações: </td> <td style="padding:0"><b>{point.y}</b></td></tr>' +
              '<tr><td style="color:#E5502C;padding:0"> Mínimo: </td> <td style="padding:0"><b>{point.min:,.2f}</b></td></tr>' +
              '<tr><td style="color:#E5502C;padding:0"> Máximo: </td> <td style="padding:0"><b>{point.max:,.2f}</b></td></tr>' +
              '<tr><td style="color:#E5502C;padding:0"> Média por Faixa: </td> <td style="padding:0"><b>{point.media:,.2f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0,
              borderWidth: 0,
              groupPadding: 0,
              shadow: false
            }
          },
          series: [
            {
              name: 'Faixa',
              color: this.seriesColor,
              //data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6],
              data: this.histogramaData,
              turboThreshold: 0,
              boostThreshold: 0,
              cursor: 'pointer',
              events: {
                click: (event) => {
                  this.openDialogCenario(event.point.options.faixa);
                }
              }
            }
          ],
          lang: {
            noData: 'Não há dados'
          },
          noData: {
            style: {
              fontWeight: 'bold',
              fontSize: '15px',
              color: '#303030'
            }
          }
        };
      }
    },

    mounted() {
      this.getDataPredicaoHistograma();
    },

    methods: {
      openDialogCenario(faixa) {
        PredicoesBaixasService.getCenario(this.idPredicao, this.idBaixaTucagem, faixa, this.variavelValor)
          .then(() => this.$toast.info('O cenário está sendo processado.', '', { position: 'topRight' }))
          .catch((err) => {
            console.log(err);
            this.$toast.error('Erro ao processar o cenário.', '', { position: 'topRight' });
          })
          .finally(() => this.$emit('recharge'));
      },
      getDataPredicaoHistograma() {
        PredicoesBaixasService.getPredicaoHistograma(this.idPredicao, this.idBaixaTucagem, this.variavelValor)
          .then((response) => {
            response.data.histograma.forEach((element) => {
              this.histogramaData.push({
                faixa: parseInt(element.dtf_freq),
                y: parseFloat(element.dtf_qtd),
                min: parseFloat(element.dtf_vnr_min),
                max: parseFloat(element.dtf_vnr_max),
                media: parseFloat(element.dtf_vnr_med)
              });
            });
            this.loaded = true;
          })
          .catch((error) => console.log(error));
      }
    }
  };
</script>